<template>
    <div class="checkout-address-form">
        <div class="checkout">
            <form id="contact-form">
                <p class="centre" v-if="isError">
                    <span class="error-label"><i class="fa fa-exclamation-triangle bold"></i> Please enter the required fields in the form.</span>
                </p>
                <div class="checkout-form">
                    <label>Name</label>
                    <input
                    class="form-control"
                    type="text"
                    v-model="message.customerName"
                    />
                </div>
                <div class="checkout-form">
                    <label>Email</label>
                    <input
                    class="form-control"
                    type="text"
                    v-model="message.customerEmail"
                    :class="{ 'danger-border': this.formErrors.emailError }"
                    />
                    <span class="error-label" v-if="this.formErrors.emailError">
                        <i class="fa fa-exclamation-triangle tip"><span class="large">Required and must be a valid email</span></i>
                    </span>
                </div>
                <div class="checkout-form" v-if="pageType==='EmailForm'">
                    <label>Type of Enquiry</label>
                    <select
                    class="form-control"
                    v-model="message.messageType"
                    >
                    <option value="General">General</option>
                    <option value="Books For Sale">Books For Sale</option>
                    <option value="Book Search">Book Search</option>
                    <option value="Website">Website</option>
                    <option value="Order">Order</option>
                    <option value="Other">Other</option>
                    <option value="Newsletter" hidden>Newsletter</option>
                    </select>
                </div>
                <div class="checkout-form enquiry-form" v-if="pageType==='EmailForm'">
                    <label>Enquiry</label>
                    <textarea
                      class="form-control"
                      v-model="message.messageBody"
                      :class="{ 'danger-border': this.formErrors.enquiryError }"
                    />
                    <span class="error-label" v-if="this.formErrors.enquiryError">
                        <i class="fa fa-exclamation-triangle tip"><span class="large">Required field</span></i>
                    </span>
                </div>
            </form>
            <div class="checkout-form-buttons">
              <p class="centre">
                <vue-recaptcha sitekey="6LeQu30aAAAAALauTUgRLPcypfT2lSH_014whDr1" :loadRecaptchaScript="true">
                  <button
                    class="btn btn-default"
                    v-on:click="sendEnquiry"
                  >
                    <span v-if="pageType==='EmailForm'">Send Enquiry</span>
                    <span v-if="pageType==='NewsletterForm'">Sign Up</span>
                  </button>
                </vue-recaptcha>
              </p>
            </div>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'email-form',
  props: ['pageType'],
  methods: {
    async sendEnquiry() {
      if (this.pageType === 'EmailForm') {
        this.formErrors.enquiryError = this.checkHasValue(this.message.messageBody);
      }
      this.formErrors.emailError = !this.checkValueIsEmail(this.message.customerEmail);
      const errorArray = Object.values(this.formErrors);
      const checker = arr => arr.some(v => v === true);
      this.isError = checker(errorArray);
      if (!this.isError) {
        await this.$store.dispatch('sendMessage', this.message);
        if (this.pageType === 'NewsletterForm') {
          this.$router.push('/thank-you/newsletter');
        } else {
          this.$router.push('/thank-you/enquiry');
        }
      }
    },
    checkHasValue(object) {
      return object === undefined || object === null || object === '';
    },
    checkValueIsEmail(object) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(object);
    },
  },
  data() {
    return {
      message: {
        customerName: '',
        customerEemail: '',
        messageType: this.pageType === 'NewsletterForm' ? 'Newsletter' : 'General',
        messageBody: '',
      },
      isError: false,
      formErrors: {
        emailError: false,
        enquiryError: false,
      },
    };
  },
  components: {
    VueRecaptcha,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content/EmailForm.vue